import { render, staticRenderFns } from "./invoiceDetailDialog.vue?vue&type=template&id=355ceef8&scoped=true"
import script from "./invoiceDetailDialog.vue?vue&type=script&lang=js"
export * from "./invoiceDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ceef8",
  null
  
)

export default component.exports